import dayjs from 'dayjs';
import {
  createDetailTableRangeFilter,
  DetailTableRangeFilterRef,
  RangeFilterConditionType,
  RangeFilterModel
} from './DetailTableRangeFilter';

// `<input type="date">` only accepts this format, and dayjs parses it unambiguously.
const INPUT_DATE_FORMAT = 'YYYY-MM-DD';

type DateRangeFilterCondition = {
  filterType: 'date';
  type: RangeFilterConditionType;
  dateFrom: string;
};

export type DateRangeFilterModel = RangeFilterModel<'date', DateRangeFilterCondition>;

export type DetailTableDateRangeFilterRef = DetailTableRangeFilterRef<DateRangeFilterModel>;

// Persisted filters arrive as MM/DD/YYYY (see formatFilterDate) while the grid model
// and the date inputs use YYYY-MM-DD, so normalize whatever shape we are handed.
function toInputDate(value: string | null | undefined): string {
  if (!value) return '';
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(INPUT_DATE_FORMAT) : '';
}

// Both bounds are inclusive, so filtering a whole month is From 07/01 / To 07/31 rather
// than the off-by-a-day workaround the greater-than/less-than dropdown forced (BUD-18569).
export const DetailTableDateRangeFilter = createDetailTableRangeFilter<'date', DateRangeFilterCondition, string>({
  displayName: 'DetailTableDateRangeFilter',
  name: 'date-range',
  filterType: 'date',
  inputType: 'date',
  helperText: 'From and To both include the date you enter.',
  createCondition: (type, dateFrom) => ({ filterType: 'date', type, dateFrom }),
  readConditionInput: (condition) => toInputDate(condition.dateFrom),
  parseInput: (rawInput) => (rawInput !== '' && dayjs(rawInput).isValid() ? rawInput : null),
  isInvertedRange: (from, to) => dayjs(from).isAfter(dayjs(to), 'day')
});
